import { Link } from 'react-router-dom';
import { topics } from '@/mocks/feed';
import SectionHeading from '@/components/base/SectionHeading';

export default function TopicSection() {
  return (
    <section id="topics" className="border-y border-background-200/70 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="Night Columns"
          title="深夜专题，每个时段一个视角"
          desc="把整夜切成几段来看，你会发现同一条话题，在午夜和在清晨被讨论的方式几乎完全不同。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {topics.map((topic) => (
            <Link
              key={topic.title}
              to={topic.href}
              className="group relative flex h-[300px] flex-col justify-end overflow-hidden rounded-lg border border-background-200/70 md:h-[360px]"
            >
              <img
                src={topic.image}
                alt={`${topic.title}专题配图`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/70 to-background-50/10" />
              <div className="relative p-5">
                <span className="font-label text-xs tracking-widest text-accent-400">{topic.count}</span>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950">{topic.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-700">{topic.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 font-label text-xs text-primary-300">
                  查看专题
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}